export default __webpack_public_path__ + "static/media/zine-artwork3.22de29c3.jpg";